module.exports = __webpack_public_path__ + "static/media/bombmax-512.4cbaa715.png";